import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IMessageTemplate,
    MessageTemplate,
} from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { map } from 'rxjs/operators';

@Injectable()
export class MessageTemplateService extends ODataService<IMessageTemplate, string> {
    protected _endpoint = 'odata/MessageTemplates';

    constructor(http: HttpClient) {
        super(http, MapperService.messageTemplateMap);
    }

    public getTemplate(template: MessageTemplate) {
        return this.get({
            filter: {
                'Name': template,
            },
        }).pipe(
            map(result => {
                const [found] = result.data;
                return found;
            }),
        );
    }
}
